import { call, cancelled } from "redux-saga/effects";
import { ngdUserManagementConfig } from "./endpoints";

export type TApiResult<T = any> = [boolean, T, Response];

/*
 */
export function* fetchSaga(url: string, init?: RequestInit) {
    const abortController = new AbortController();
    try {
        return yield call(fetchRoutine, url, {
            ...init,
            signal: abortController.signal,
            headers: addTestHeader(init?.headers),
        });
    } catch (e) {
        if (yield cancelled()) {
            abortController.abort();
            return [false, "aborted", null];
        }
        return [false, e.toString(), null];
    }
}

const testReg = /test_cookie_key=([^;]+)/;

function addTestHeader(headers) {
    const testMatch = document.cookie.match(testReg);
    if (!testMatch || testMatch.length < 2) return headers;

    return {
        ...headers,
        testKey: testMatch[1],
    };
}

async function fetchRoutine(
    url: string,
    init?: RequestInit
): Promise<TApiResult> {
    let response: Response = null;
    try {
        response = await fetch(url, init);
    } catch (e) {
        return [false, { error: e, message: e.toString() }, null];
    }

    let text: string;
    try {
        text = await response.text();
    } catch (e) {
        return [false, { error: e, message: e.toString() }, response];
    }

    if (!response.ok) {
        let server = true;
        try {
            server = JSON.parse(text);
        } finally {
            return [
                false,
                { server, message: text || response.statusText },
                response,
            ];
        }
    }

    let data;
    try {
        data = text ? JSON.parse(text) : null;
    } catch (e) {
        return [false, { error: e, message: e.toString() }, response];
    }

    return [true, data, response];
}

/*
 */
export const getJsonSaga = (token, url) =>
    call(fetchSaga, ngdUserManagementConfig.apiUrl + url, {
        credentials: "same-origin",
        headers: {
            Authorization: "Bearer " + token,
        },
    });

/*
 */
export const postJsonSaga = (token, url, data) =>
    call(fetchSaga, ngdUserManagementConfig.apiUrl + url, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });

/*
 */
export const putJsonSaga = (token, url, data) =>
    call(fetchSaga, ngdUserManagementConfig.apiUrl + url, {
        method: "PUT",
        credentials: "omit",
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
